import { render, staticRenderFns } from "./pos-addVendorPayment.vue?vue&type=template&id=590c754e"
import script from "./pos-addVendorPayment.vue?vue&type=script&lang=js"
export * from "./pos-addVendorPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports